import React, { useEffect, useMemo, useState } from 'react';

import { Box, Paper, Typography, useTheme } from '@mui/material';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { HelpdeskCard } from './HelpdeskCard';
import api from '../../../../../services/api';

function HelpdeskDelayCard() {
  const theme = useTheme();
  const [total, setTotal] = useState({ delay: 0, open: 0 });
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.get<{ total: number }>('v2/helpdesk/dashboard/my/delay');
      const { data: open } = await api.get<{ total: number }>('v2/helpdesk/dashboard/my/open');
      const newTotal = total;
      newTotal.delay = data.total;
      newTotal.open = open.total;

      setTotal(newTotal);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const renderCard = useMemo(() => {
    return (
      <HelpdeskCard
        loading={loading}
        title="Solicitações em atraso"
        content={
          <Typography variant="h3" fontWeight="400">
            {Intl.NumberFormat('pt-BR').format(total.delay)}
          </Typography>
        }
        subcontent={
          <Typography variant="caption">
            {total.open > 0 ? `${((total.delay / total.open) * 100).toFixed(0)}% em atraso` : '0% em atraso'}
          </Typography>
        }
        icon={<RemoveCircleOutlineOutlinedIcon color="error" sx={{ fontSize: 64 }} />}
        color={theme.palette.error.main}
      />
    );
  }, [theme.palette.error.main, total.delay, total.open, loading]);
  return renderCard;
}

export { HelpdeskDelayCard };
